import { useEffect } from "react";
import { useLocation } from "react-router-dom";

/**
 * React Router keeps the scroll offset across navigations, so moving from the
 * bottom of /projects to /contact used to land you mid-page. Reset on route
 * change (jump, not smooth: a smooth scroll here fights the page transition).
 */
const ScrollToTop = () => {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo({ top: 0, left: 0, behavior: "instant" });
  }, [pathname]);

  return null;
};

export default ScrollToTop;
